module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp123_0.a2f854b7.png";